import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { getPspPartnerPaymentType } from '../helpers/get-enums-names';
import { PspPartnerPaymentType } from '../types';

export const bankAndPspListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'companyName',
    label: 'Bank',
    sortable: true,
  },
  {
    name: 'active',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'paymentsTypes',
    label: 'Supported type',
    sortable: true,
  },
];

export const bankAndPspListColumnsLabels = {
  companyName: 'Bank',
  active: 'Status',
  paymentsTypes: 'Supported type',
};

export const bankAndPspListDefaultSorter = {
  sortProp: bankAndPspListColumns[1].name,
  sortDir: SortDir.ASC,
};

export const bankAndPspListSchema = {
  companyName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentsTypes: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, bankAndPspListDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, bankAndPspListDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const bankAndPspListFiltersSchema = [
  {
    name: 'companyName',
    type: FilterType.TEXT,
    placeholder: 'Enter company name...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Disabled',
        value: 'false',
      },
    ],
  },
  {
    name: 'paymentsTypes',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.FASTER_PAYMENT),
        value: PspPartnerPaymentType.FASTER_PAYMENT,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.BACS),
        value: PspPartnerPaymentType.BACS,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.SEPA_SCT_INST),
        value: PspPartnerPaymentType.SEPA_SCT_INST,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.SEPA_SCT),
        value: PspPartnerPaymentType.SEPA_SCT,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.TARGET_2),
        value: PspPartnerPaymentType.TARGET_2,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.SWIFT),
        value: PspPartnerPaymentType.SWIFT,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(PspPartnerPaymentType.FEDWIRE),
        value: PspPartnerPaymentType.FEDWIRE,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(
          PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT,
        ),
        value: PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT,
      },
      {
        name: 'paymentsTypes',
        title: getPspPartnerPaymentType(
          PspPartnerPaymentType.CASH_OVER_COUNTER,
        ),
        value: PspPartnerPaymentType.CASH_OVER_COUNTER,
      },
    ],
  },
];
